import { AbstractControl, ValidationErrors } from '@angular/forms';

export const plNotBlankValidator = (
  control: AbstractControl
): ValidationErrors | null => {
  const { value } = <{ value: string }>control;
  return value?.trim() ? null : { notblank: undefined };
};
